import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { Form } from 'libs/forms/index';
import { Trans } from 'react-i18next';

@observer
export class PublishStory extends Modal {
  render() {
    const { storyApp } = this.props;
    const { publishForm } = storyApp;
    const {
      conf: { formTitle },
    } = publishForm;

    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={publishForm}
          formTitle=''
          buttonHandler={storyApp.Save}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
